import React from 'react';

const HighlightText = ({ text, query }) => {
  if (!query || !text) return <>{text}</>;

  const index = text.toLowerCase().indexOf(query.toLowerCase());
  if (index === -1) return <>{text}</>;

  return (
    <>
      {text.slice(0, index)}
      <mark style={{ backgroundColor: '#ffe066', padding: 0 }}>{text.slice(index, index + query.length)}</mark>
      {text.slice(index + query.length)}
    </>
  );
};

export default HighlightText;
